import { IWallet } from '@efex-services/client/types';

export const dataSelectDashboard = [
  { id: 1, date: '10/06/21', name: 'Client Name 1' },
  {
    id: 2,
    date: '10/06/22',
    name: 'Client Name 2',
  },
  { id: 3, date: '10/06/23', name: 'Client Name 3' },
  { id: 4, date: '10/06/24', name: 'Client Name 4' },
];

export const walletsResponse: IWallet[] = [
  {
    id: 1,
    wallet: {
      uuid: 'baseData',
      default_currency: 'USD',
      wallet_type: 1,
      id: 1234,
    },
    currency: {
      id: 1,
      name: 'USD',
    },
    balance: '0.0',
    blocked: '0.0',
  },
  {
    id: 2,
    wallet: {
      uuid: 'baseData',
      default_currency: 'USD',
      wallet_type: 1,
      id: 1234,
    },
    currency: {
      id: 2,
      name: 'MXN',
    },
    balance: '0.0',
    blocked: '0.0',
  },
  {
    id: 3,
    wallet: {
      uuid: 'baseData',
      default_currency: 'USD',
      wallet_type: 1,
      id: 1234,
    },
    currency: {
      id: 3,
      name: 'COP',
    },
    balance: '0.0',
    blocked: '0.0',
  },
];
